import { Colors, Media, Spacing } from '@doordash/design-language'
import styled from 'styled-components'

export const SectionContainer = styled.section`
  border-bottom: 1px solid ${Colors.BorderPrimary};
  padding: ${Spacing.XxLarge}px 0px ${Spacing.XxLarge}px 0px;
  ${Media.Mobile`
    padding: ${Spacing.Large}px 0px ${Spacing.Small}px; 0px;
`};
`

export default SectionContainer
